// Global promise that resolves with window.YT once the YouTube iframe API is ready.
// https://developers.google.com/youtube/iframe_api_reference
//
// There must be exactly one of these: each copy owns window.onYouTubeIframeAPIReady,
// and a second copy replaced the first so its promise never resolved. The shared
// library's renderer installs the handler, so web uses that same promise. The
// iframe_api script itself is still injected once, by AppContainer, gated on consent.
import { youtubeReady } from '@plickers/now-player-library/renderer'

export default youtubeReady
